// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType } from '../DataCacheToolEnums';
import { DataCacheTool } from '../DataCacheTool';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { SolidBrush } from '../../Graphics';
import { DynProperty } from '../../DynProperty';
export class ElliotWavesDataCacheTool extends DataCacheTool {
    constructor(toolType) {
        super();
        this.ToolType = toolType;
        switch (toolType) {
            case DataCacheToolType.ElliottImpulse:
                this.InitPoints(6);
                this.Color = ThemeManager.colors.chartElliotImpulseColor;
                break;
            case DataCacheToolType.ElliottCorrection:
                this.InitPoints(4);
                this.Color = ThemeManager.colors.chartElliotCorrectionColor;
                break;
            case DataCacheToolType.ElliottTriangle:
                this.InitPoints(6);
                this.Color = ThemeManager.colors.chartElliotTriangleColor;
                break;
            case DataCacheToolType.ElliottTripleCombo:
                this.InitPoints(6);
                this.Color = ThemeManager.colors.chartElliotTripleComboColor;
                break;
            case DataCacheToolType.ElliottDoubleCombo:
                this.InitPoints(4);
                this.Color = ThemeManager.colors.chartElliotDoubleComboColor;
                break;
        }
    }
    MinPointsCount() {
        return this.Points.length;
    }
    ThemeChanged() {
        super.ThemeChanged();
        this.labelBackgroundColor = ThemeManager.colors.chartElliotLabelsBackground;
        this.labelBackgroundBrush = new SolidBrush(this.labelBackgroundColor);
        this.labelBackgroundSelectedBrush = new SolidBrush(ThemeManager.colors.chartElliotLabelsBackgroundSelected);
        this.FontColor = ThemeManager.colors.chartElliotWavesForeground;
        this.foregroundSelectedBrush = new SolidBrush(ThemeManager.colors.chartElliotWavesForegroundSelected);
        this.font = ThemeManager.Fonts.Font_12F_regular;
    }
    Properties() {
        const props = super.Properties();
        if (this.FontColor != null) {
            props.push(new DynProperty('ElliotWaves.Font', this.FontColor, DynProperty.COLOR, DynProperty.VISUAL_GROUP));
        }
        return props;
    }
    callBack(properties) {
        super.callBack(properties);
        const prop = DynProperty.getPropertyByName(properties, 'ElliotWaves.Font');
        if (prop != null)
            this.FontColor = prop.value;
    }
}
